import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../dishFullInfoState/dishFullInfoContext';
import style from './EditBtn.module.scss';

const EditBtn: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<Link to={`/menu/dishes/edit?dishID=${dishForFullInfo?.id}`}>
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}>
				<Text translationNameSpace="form" translationKey="editDishButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default EditBtn;
